import { useEffect } from 'react';

import { TOKEN_SCOPE, usePostRecentProject, useServiceAppState } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

/**
 * 콘솔 입장시 현재 프로젝트로 최근 접속 프로젝트로 최신화합니다.
 */
const useRecentProjectEffect = () => {
  const {
    state: { projectId, status, scope },
  } = useServiceAppState();

  const { mutate } = usePostRecentProject();
  useEffect(() => {
    if (status !== STATUS_CODE.OK) return;

    if (scope !== TOKEN_SCOPE.PROJECT) return;

    if (!projectId) return;
    mutate({ projectId });
  }, [mutate, projectId, scope, status]);
};

export default useRecentProjectEffect;
